// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toggle-menu[data-v-5ff9ddc6],.toggle-menu>div[data-v-5ff9ddc6]{align-items:center;display:flex;justify-content:center}.toggle-menu>div[data-v-5ff9ddc6]{background-color:transparent;border:0;height:1.6rem;padding:0;width:1.6rem}.toggle-menu>div svg[data-v-5ff9ddc6]{width:100%;fill:#383838}@media(hover:hover){.toggle-menu[data-v-5ff9ddc6]{cursor:pointer}.toggle-menu:hover svg[data-v-5ff9ddc6]{opacity:.6}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
